// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"klaviyo_wrapper__96dkr","formStyle":"klaviyo_formStyle__RNj99"};